// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Masters config (Modalities / Modality Groups) ───────────────────────
   Visual language mirrors the View Notes dialog (view-notes.scss):
   teal accent, slate text, light panel heads, rounded cards.            */

.masters-config-container {
  --mc-border: #e3e6eb;
  --mc-muted: #6b7280;
  --mc-strong: #1f2937;
  --mc-accent: #0f766e;        /* teal-700 */
  --mc-accent-hover: #0d655e;
  --mc-accent-soft: #ccfbf1;   /* teal-100 */
  --mc-accent-dark: #134e4a;
  --mc-head-bg: #f3f5f8;

  padding: 16px;
  font-size: 13px;
  min-height: 100%;
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
}

/* ── Title bar ────────────────────────────────────────────────────────── */

.masters-config-container .mc-titlebar {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: justify;
      -ms-flex-pack: justify;
          justify-content: space-between;
  gap: 12px;
  margin-bottom: 14px;
}

.masters-config-container .mc-title {
  font-size: 0.95rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #334155;
}

/* ── Toolbar (search + filters) ───────────────────────────────────────── */

.masters-config-container .mc-toolbar {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 10px;
  -ms-flex-wrap: wrap;
      flex-wrap: wrap;
  margin-bottom: 14px;
}

/* ── Panel wrapper ────────────────────────────────────────────────────── */

.masters-config-container .mc-panel {
  border: 1px solid var(--mc-border);
  border-radius: 8px;
  overflow: hidden;
  background: #fff;
}

.masters-config-container .mc-panel-head {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: justify;
      -ms-flex-pack: justify;
          justify-content: space-between;
  gap: 6px;
  padding: 8px 12px;
  background: var(--mc-head-bg);
  border-bottom: 1px solid var(--mc-border);
  font-size: 0.74rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #475569;
}

.masters-config-container .mc-count {
  font-size: 0.66rem;
  font-weight: 700;
  color: #fff;
  background: var(--mc-accent);
  border-radius: 10px;
  padding: 0 7px;
  line-height: 16px;
}

.masters-config-container .mc-panel-body {
  padding: 10px 12px;
}

/* ── Table ────────────────────────────────────────────────────────────── */

.masters-config-container .mc-table .ant-table-thead > tr > th {
  background: #f8fafc;
  color: #475569;
  text-transform: uppercase;
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.03em;
  border-bottom: 1px solid var(--mc-border);
}

.masters-config-container .mc-table .ant-table-tbody > tr > td {
  font-size: 0.8rem;
  color: var(--mc-strong);
}

.masters-config-container .mc-table .ant-table-tbody > tr:hover > td {
  background: #f6f8fa;
}

/* ── Tags (modality codes / group members) = teal chips ───────────────── */

.masters-config-container .ant-tag {
  color: var(--mc-accent);
  background: var(--mc-accent-soft);
  border: none;
  border-radius: 4px;
  font-weight: 700;
  font-size: 0.7rem;
  letter-spacing: 0.02em;
  padding: 0 7px;
  -webkit-margin-end: 4px;
          margin-inline-end: 4px;
}

/* ── Accent overrides shared with the modal ───────────────────────────── */

.masters-config-container .ant-btn-primary,
.masters-config-modal .ant-btn-primary {
  background: var(--mc-accent, #0f766e);
  border-color: var(--mc-accent, #0f766e);
}

.masters-config-container .ant-btn-primary:hover,
.masters-config-modal .ant-btn-primary:hover {
  background: #0d655e !important;
  border-color: #0d655e !important;
}

.masters-config-container .ant-switch-checked,
.masters-config-modal .ant-switch-checked {
  background: var(--mc-accent, #0f766e);
}

.masters-config-container .ant-btn-link {
  color: var(--mc-accent, #0f766e);
}

.masters-config-container .ant-btn-link.ant-btn-dangerous {
  color: #dc2626;
}

/* ── Error box ────────────────────────────────────────────────────────── */

.masters-config-container .mc-error {
  padding: 14px;
  background: #fff2f0;
  border: 1px solid #ffccc7;
  border-radius: 8px;
  margin-bottom: 14px;
  text-align: center;
}

.masters-config-container .mc-error p {
  color: #ff4d4f;
  margin-bottom: 8px;
}

/* ── Modal ────────────────────────────────────────────────────────────── */

.masters-config-modal .ant-modal-title {
  text-transform: uppercase;
  letter-spacing: 0.04em;
  font-size: 0.85rem;
  font-weight: 700;
  color: #334155;
}

.masters-config-modal .form-actions {
  text-align: right;
  margin-bottom: 0;
}

.masters-config-modal .form-actions .ant-form-item-control-input-content {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: end;
      -ms-flex-pack: end;
          justify-content: flex-end;
  gap: 8px;
}
`, "",{"version":3,"sources":["webpack://./pages/MastersConfig/masters-config.css"],"names":[],"mappings":"AAAA;;0EAE0E;;AAE1E;EACE,oBAAoB;EACpB,mBAAmB;EACnB,oBAAoB;EACpB,oBAAoB,SAAS,aAAa;EAC1C,0BAA0B;EAC1B,yBAAyB,IAAI,aAAa;EAC1C,yBAAyB;EACzB,qBAAqB;;EAErB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,6DAA6D;AAC/D;;AAEA,4EAA4E;;AAC5E;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,yBAA8B;MAA9B,sBAA8B;UAA9B,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA,4EAA4E;;AAC5E;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,SAAS;EACT,mBAAe;MAAf,eAAe;EACf,mBAAmB;AACrB;;AAEA,4EAA4E;;AAC5E;EACE,kCAAkC;EAClC,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,yBAA8B;MAA9B,sBAA8B;UAA9B,8BAA8B;EAC9B,QAAQ;EACR,iBAAiB;EACjB,6BAA6B;EAC7B,yCAAyC;EACzC,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,4BAA4B;EAC5B,mBAAmB;EACnB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,4EAA4E;;AAC5E;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yCAAyC;AAC3C;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,4EAA4E;;AAC5E;EACE,uBAAuB;EACvB,iCAAiC;EACjC,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;EACd,uBAAsB;UAAtB,sBAAsB;AACxB;;AAEA,4EAA4E;;AAC5E;;EAEE,qCAAqC;EACrC,uCAAuC;AACzC;;AAEA;;EAEE,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;;EAEE,qCAAqC;AACvC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,cAAc;AAChB;;AAEA,4EAA4E;;AAC5E;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA,4EAA4E;;AAC5E;EACE,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,qBAAyB;MAAzB,kBAAyB;UAAzB,yBAAyB;EACzB,QAAQ;AACV","sourcesContent":["/* ── Masters config (Modalities / Modality Groups) ───────────────────────\r\n   Visual language mirrors the View Notes dialog (view-notes.scss):\r\n   teal accent, slate text, light panel heads, rounded cards.            */\r\n\r\n.masters-config-container {\r\n  --mc-border: #e3e6eb;\r\n  --mc-muted: #6b7280;\r\n  --mc-strong: #1f2937;\r\n  --mc-accent: #0f766e;        /* teal-700 */\r\n  --mc-accent-hover: #0d655e;\r\n  --mc-accent-soft: #ccfbf1;   /* teal-100 */\r\n  --mc-accent-dark: #134e4a;\r\n  --mc-head-bg: #f3f5f8;\r\n\r\n  padding: 16px;\r\n  font-size: 13px;\r\n  min-height: 100%;\r\n  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);\r\n}\r\n\r\n/* ── Title bar ────────────────────────────────────────────────────────── */\r\n.masters-config-container .mc-titlebar {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 12px;\r\n  margin-bottom: 14px;\r\n}\r\n\r\n.masters-config-container .mc-title {\r\n  font-size: 0.95rem;\r\n  font-weight: 700;\r\n  letter-spacing: 0.06em;\r\n  text-transform: uppercase;\r\n  color: #334155;\r\n}\r\n\r\n/* ── Toolbar (search + filters) ───────────────────────────────────────── */\r\n.masters-config-container .mc-toolbar {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  flex-wrap: wrap;\r\n  margin-bottom: 14px;\r\n}\r\n\r\n/* ── Panel wrapper ────────────────────────────────────────────────────── */\r\n.masters-config-container .mc-panel {\r\n  border: 1px solid var(--mc-border);\r\n  border-radius: 8px;\r\n  overflow: hidden;\r\n  background: #fff;\r\n}\r\n\r\n.masters-config-container .mc-panel-head {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 6px;\r\n  padding: 8px 12px;\r\n  background: var(--mc-head-bg);\r\n  border-bottom: 1px solid var(--mc-border);\r\n  font-size: 0.74rem;\r\n  font-weight: 700;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.04em;\r\n  color: #475569;\r\n}\r\n\r\n.masters-config-container .mc-count {\r\n  font-size: 0.66rem;\r\n  font-weight: 700;\r\n  color: #fff;\r\n  background: var(--mc-accent);\r\n  border-radius: 10px;\r\n  padding: 0 7px;\r\n  line-height: 16px;\r\n}\r\n\r\n.masters-config-container .mc-panel-body {\r\n  padding: 10px 12px;\r\n}\r\n\r\n/* ── Table ────────────────────────────────────────────────────────────── */\r\n.masters-config-container .mc-table .ant-table-thead > tr > th {\r\n  background: #f8fafc;\r\n  color: #475569;\r\n  text-transform: uppercase;\r\n  font-size: 0.68rem;\r\n  font-weight: 700;\r\n  letter-spacing: 0.03em;\r\n  border-bottom: 1px solid var(--mc-border);\r\n}\r\n\r\n.masters-config-container .mc-table .ant-table-tbody > tr > td {\r\n  font-size: 0.8rem;\r\n  color: var(--mc-strong);\r\n}\r\n\r\n.masters-config-container .mc-table .ant-table-tbody > tr:hover > td {\r\n  background: #f6f8fa;\r\n}\r\n\r\n/* ── Tags (modality codes / group members) = teal chips ───────────────── */\r\n.masters-config-container .ant-tag {\r\n  color: var(--mc-accent);\r\n  background: var(--mc-accent-soft);\r\n  border: none;\r\n  border-radius: 4px;\r\n  font-weight: 700;\r\n  font-size: 0.7rem;\r\n  letter-spacing: 0.02em;\r\n  padding: 0 7px;\r\n  margin-inline-end: 4px;\r\n}\r\n\r\n/* ── Accent overrides shared with the modal ───────────────────────────── */\r\n.masters-config-container .ant-btn-primary,\r\n.masters-config-modal .ant-btn-primary {\r\n  background: var(--mc-accent, #0f766e);\r\n  border-color: var(--mc-accent, #0f766e);\r\n}\r\n\r\n.masters-config-container .ant-btn-primary:hover,\r\n.masters-config-modal .ant-btn-primary:hover {\r\n  background: #0d655e !important;\r\n  border-color: #0d655e !important;\r\n}\r\n\r\n.masters-config-container .ant-switch-checked,\r\n.masters-config-modal .ant-switch-checked {\r\n  background: var(--mc-accent, #0f766e);\r\n}\r\n\r\n.masters-config-container .ant-btn-link {\r\n  color: var(--mc-accent, #0f766e);\r\n}\r\n\r\n.masters-config-container .ant-btn-link.ant-btn-dangerous {\r\n  color: #dc2626;\r\n}\r\n\r\n/* ── Error box ────────────────────────────────────────────────────────── */\r\n.masters-config-container .mc-error {\r\n  padding: 14px;\r\n  background: #fff2f0;\r\n  border: 1px solid #ffccc7;\r\n  border-radius: 8px;\r\n  margin-bottom: 14px;\r\n  text-align: center;\r\n}\r\n\r\n.masters-config-container .mc-error p {\r\n  color: #ff4d4f;\r\n  margin-bottom: 8px;\r\n}\r\n\r\n/* ── Modal ────────────────────────────────────────────────────────────── */\r\n.masters-config-modal .ant-modal-title {\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.04em;\r\n  font-size: 0.85rem;\r\n  font-weight: 700;\r\n  color: #334155;\r\n}\r\n\r\n.masters-config-modal .form-actions {\r\n  text-align: right;\r\n  margin-bottom: 0;\r\n}\r\n\r\n.masters-config-modal .form-actions .ant-form-item-control-input-content {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  gap: 8px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
